/* =====================================================================
   SILLARA — Thème Shopify · interactions légères
   Aucune dépendance. Compatible Online Store 2.0.
   ===================================================================== */
(function () {
  "use strict";

  /* --- Header : transparent sur le hero, solide au scroll (accueil) --- */
  var header = document.querySelector(".site-header");
  var isIndex = document.body.classList.contains("template-index");
  function applyHeader() {
    if (!header) return;
    if (!isIndex) { header.classList.add("scrolled"); return; }
    header.classList.toggle("scrolled", window.scrollY > 60);
  }
  window.addEventListener("scroll", applyHeader, { passive: true });
  applyHeader();

  /* --- Menu mobile --- */
  var burger = document.querySelector(".burger");
  var panel = document.querySelector(".mobile-nav");
  if (burger && panel) {
    burger.addEventListener("click", function () { panel.classList.add("open"); });
    var close = panel.querySelector(".close");
    if (close) close.addEventListener("click", function () { panel.classList.remove("open"); });
    panel.querySelectorAll("a").forEach(function (a) { a.addEventListener("click", function () { panel.classList.remove("open"); }); });
  }

  /* --- Révélations au scroll --- */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } });
  }, { threshold: 0.12, rootMargin: "0px 0px -40px 0px" });
  document.querySelectorAll(".reveal").forEach(function (el) { io.observe(el); });

  /* --- Fiche produit : sélection de variante --> prix + disponibilité --- */
  var form = document.querySelector("[data-product-form], .product-form");
  if (form) {
    var priceEl = document.querySelector("[data-product-price]");
    var addBtn = form.querySelector("[data-add-to-cart]");
    var radios = form.querySelectorAll('input[name="id"]');
    function syncVariant() {
      var checked = form.querySelector('input[name="id"]:checked');
      if (!checked) return;
      if (priceEl && checked.dataset.price) priceEl.textContent = checked.dataset.price;
      var available = checked.dataset.available === "true";
      if (addBtn) {
        addBtn.disabled = !available;
        addBtn.textContent = available ? (addBtn.dataset.labelAdd || "Ajouter au panier") : (addBtn.dataset.labelSold || "Épuisé");
      }
    }
    radios.forEach(function (r) { r.addEventListener("change", syncVariant); });
    syncVariant();
  }

  /* --- Galerie produit : miniatures --> image principale --- */
  var hero = document.querySelector("[data-pdp-hero]");
  document.querySelectorAll("[data-pdp-thumb]").forEach(function (th) {
    th.addEventListener("click", function () {
      if (hero) hero.innerHTML = th.innerHTML;
    });
  });

  /* --- Fermeture des dropdowns de facettes au clic extérieur --- */
  document.addEventListener("click", function (e) {
    document.querySelectorAll(".facets details[open]").forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute("open");
    });
  });

  /* --- Panier : boutons +/- pilotent le champ quantité --- */
  document.querySelectorAll("[data-qty]").forEach(function (q) {
    var input = q.querySelector("input");
    var minus = q.querySelector("[data-qty-minus]");
    var plus = q.querySelector("[data-qty-plus]");
    if (minus) minus.addEventListener("click", function () { input.value = Math.max(0, (parseInt(input.value, 10) || 0) - 1); autoUpdate(); });
    if (plus) plus.addEventListener("click", function () { input.value = (parseInt(input.value, 10) || 0) + 1; autoUpdate(); });
  });
  var cartForm = document.querySelector("[data-cart-form]");
  function autoUpdate() {
    // Soumet le formulaire panier pour recalculer les totaux via Shopify.
    if (cartForm) cartForm.requestSubmit ? cartForm.requestSubmit(cartForm.querySelector('[name="update"]')) : cartForm.submit();
  }
})();
